export const UPLOAD_FILE = 'UPLOAD_FILE';
export const UPLOAD_FILE_LOADING = 'UPLOAD_FILE_LOADING';
export const SET_UPLOAD_DIALOG_ID = 'SET_UPLOAD_DIALOG_ID';
export const UPLOAD_FILE_ERROR = 'UPLOAD_FILE_ERROR';
export const RESET_UPLOAD_FILE = 'RESET_UPLOAD_IMAGE';
